module.exports = __webpack_public_path__ + "img/featureSlide04Img_03.60f944b6.png";